import React from 'react';
import { useHistory } from 'react-router-dom';

import AppBar from 'components/AppBar';
import Button from 'components/Buttons/Button';
import ProgressSteps from 'components/ProgressSteps';
import { WizardProps } from 'components/Wizard';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, PaddingContainer, HeaderCenter, BottomEndBackground, GroupButton } from '../../styles';

interface Props {
  wizard: WizardProps;
}

const EndOnboarding = ({ wizard }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  return (
    <Container>
      <nav>
        <AppBar goBack={() => {}} noGoBack>
          {t('endOnboarding.title')}
        </AppBar>
        <ProgressSteps size={wizard.size} currentStep={wizard.currentStep} />
      </nav>
      <PaddingContainer>
        <HeaderCenter>
          <h3>{t('endOnboarding.header')}</h3>
        </HeaderCenter>
      </PaddingContainer>
      <BottomEndBackground>
        <p>{t('endOnboarding.info')}</p>
      </BottomEndBackground>
      <GroupButton>
        <Button onClick={() => history.push('/dashboard')} disabled={false} value={t('endOnboarding.nextButton')} />
      </GroupButton>
    </Container>
  );
};

EndOnboarding.defaultProps = {
  wizard: {},
};

export default EndOnboarding;
